import {
  ListViewResultIcon,
  ListViewResultMeta,
  ListViewResultRow,
  ListViewResultSection,
  ListViewResultTitle,
  SearchResultItem,
  StyledSearchResultsItemTitle,
} from "../../../../../share/searchResults";
import Jp from "../../../../../assets/svg/jpIcon.svg";
import { useActions } from "../../../../../hooks/useActions";
import { CurrentCompany } from "../../../../../models/CurrentCompany";
import { formatSearchResultTitle } from "../../../../../util/stringUtil";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../../constants";

type Props = {
  key: number;
  mapObject: CurrentCompany;
};

const CompanySearchResultItem = ({ key, mapObject }: Props) => {
  const { setCurrentMarker, getCurrentMapCompany } = useActions();
  const { id } = useTypedSelector((state) => state.currentAccount);
  const isListViewActive = useTypedSelector(
    (state) => state.mapInterface.isListViewActive
  );
  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListViewActive && !isMobile;

  const handleClickSearchResult = (mapObject: CurrentCompany) => {
    const hashId = mapObject.RECORD;
    getCurrentMapCompany(hashId, id);
  };

  const title = formatSearchResultTitle(mapObject.SHORT_NAME || mapObject.NAME);
  return (
    <SearchResultItem
      hashId={mapObject.RECORD}
      key={key}
      onMouseEnter={() =>
        setCurrentMarker({
          lon: +mapObject.lat,
          lat: +mapObject.lon,
        })
      }
      onMouseLeave={() => setCurrentMarker({ lon: 0, lat: 0 })}
      onClick={() => handleClickSearchResult(mapObject)}
    >
      {shouldRenderListView ? (
        <ListViewResultRow>
          <ListViewResultIcon>
            <img src={Jp} alt="" />
          </ListViewResultIcon>
          <ListViewResultSection flex="2 1 320px">
            <ListViewResultTitle>{title}</ListViewResultTitle>
            <ListViewResultMeta>{mapObject.EDRPOU || "—"}</ListViewResultMeta>
          </ListViewResultSection>
          <ListViewResultSection flex="1 1 200px">
            <ListViewResultMeta>{mapObject.STAN || "—"}</ListViewResultMeta>
          </ListViewResultSection>
          <ListViewResultSection flex="1 1 200px">
            <ListViewResultMeta>
              {mapObject.registration_date_1 || "—"}
            </ListViewResultMeta>
          </ListViewResultSection>
        </ListViewResultRow>
      ) : (
        <>
          <img src={Jp} alt="" />
          <StyledSearchResultsItemTitle>{title}</StyledSearchResultsItemTitle>
          <p>{mapObject.EDRPOU}</p>
          <p>
            {mapObject.STAN} &middot;
            {" " + mapObject.registration_date_1 + " "}
          </p>
        </>
      )}
    </SearchResultItem>
  );
};

export default CompanySearchResultItem;
